import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/auth/Login'
import store from '@/store'
import DashboardLayout from '@/pages/Layout/DashboardLayout.vue'
import Shops from '@/components/shops/ShopIndex.vue'
import CashBox from '@/components/cashbox/CashIndex.vue'
import Users from '@/components/users/UsersIndex.vue'
import Registations from '@/components/registrationRequests/RegIndex.vue'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next({name: 'Dashboard'})
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next({name: 'Login'})
}

export default new Router({
  mode: 'history',
  base: '/admin/',
  routes: [
    {
      path: '/',
      component: DashboardLayout,
      children: [
        // eslint-disable-next-line standard/object-curly-even-spacing
        {path: '', name: 'Dashboard', component: Shops},
        // eslint-disable-next-line standard/object-curly-even-spacing
        {path: 'shop', name: 'Shops', component: Shops},
        {path: 'cashbox', name: 'CashBox', component: CashBox},
        {path: 'cashbox/:id', name: 'CashBoxByID', component: CashBox},
        {path: 'users', name: 'Users', component: Users},
        {path: 'users/:id', name: 'UsersById', component: Users},
        {path: 'registration', name: 'Registration', component: Registations}
      ],
      beforeEnter: ifAuthenticated
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    // catch all redirect
    {
      path: '*',
      redirect: {name: 'Dashboard'},
      beforeEnter: ifNotAuthenticated
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js